module.exports = __webpack_public_path__ + "static/media/Layout1.73188b88.png";